import React, { useEffect } from 'react';
import { useState } from 'react';
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../../components/useDynamic/Button_DynamicStyle";
import { Col, Row } from "react-bootstrap";
import Dropdown from "../../components/dropdowns/Dropdown.js";
import { createAndUpdatePinned, getPromotion, pinnedPromotion } from "../../api/promotion_api.js";
import{createAndUpdatePinnedNews, getNewsEvent, pinnedNewsEvent}  from "../../api/news_event_api.js"; 
import {
    alertConfirmSave,
    alertSaved,
} from "../../components/alertValid/AlertValid.js"

function Pinned({ type }) {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );

    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [inputForm, setInputForm] = useState([
        {pin:0},{pin:0},{pin:0},{pin:0},{pin:0}
    ]);
    const [DataDropPin, setDataDropPin] = useState([]);
    const [filterDropPin, setfilterDropPin] = useState([]);
    const [valuefromparent1, setValuefromparent1] = useState(Array(5).fill("--- please select ---"));
   

    useEffect(() => {
        filterNotInDropPin()
    }, [inputForm, DataDropPin])

    function getCountExistsSelect() {
        return inputForm.filter(item => item.pin != 0).length > 0
    }
   

    function filterNotInDropPin() {
        const countExistsSelect = inputForm.filter(item => item.pin != 0)
        const t = countExistsSelect.length > 0 ? [] : [...DataDropPin]
        const refset = new Set(DataDropPin.filter(item => item.value != 0).map(item => item.value))

        const set = new Set()
        for(let i = 0 ; i < inputForm.length; i++) {
            const formItem = inputForm[i]
            set.add(formItem.pin)
        }

        const result = refset.difference(set)
        const map_result = []
        result.forEach(setItem => {
            const indxFromDropin = DataDropPin.filter(item => item.value == setItem)
            if(indxFromDropin.length > 0) map_result.push(indxFromDropin[0])
        })
        setfilterDropPin([{value: 0, text: "--- please select ---"}, ...map_result])
    }

    function setinput(index, inputname, value) {
        if(typeof value === "string")
        {
            setInputForm((prev) => {
                const newForm = [...prev];
                newForm[index] = {
                    ...newForm[index],
                    [inputname]: value,
                };
                return newForm;
            });
        }
    }

    const handlePinChange = (index, value) => {
        setinput(index, 'pin', value);
    };

    const ChangesetValuefromparent1 = (index, text, value) => {
        setValuefromparent1((prev) => {
            const newValues = [...prev];
            newValues[index] = text;
            return newValues;
        });
        
    }

    const getPinDropDown = async () => {
        try {
            const param = {
                type: type,
                active:1,
                rank: 99
            }

            const paramTop5 = {
                type: type,
            }
            if(type=='promo'||type=='priv')
            {  
                let responsePromo = await getPromotion(param);
                let responseTop5 = await pinnedPromotion(paramTop5);

                if (responsePromo.status === 200 && responseTop5.status == 200) {               
                    let dataPin = [];
                    let dataTop5 = []
                
                    responsePromo.data.data.forEach((item) => {
                        dataPin.push({
                            value: item._id,
                            text: item.title_en + ' - ' + item.title_th,
                            rank: item.rank
                        });
                    });
                    responseTop5.data.data.forEach((item) => {
                        dataPin.push({
                            value: item._id,
                            text: item.title,
                            rank: item.rank
                        });
                    });
                 
                    if (dataPin.length > 0) {
                        for(let idx=0;idx < valuefromparent1.length;idx++){
                            const item = dataPin.find(x => x.rank == idx + 1);
                            let text = item!=null ? item.text ?? valuefromparent1[idx] : valuefromparent1[idx];
                            ChangesetValuefromparent1(idx, text)
                        }
                        for(let idx=0;idx < inputForm.length;idx++){
                            const item = dataPin.find(x => x.rank == idx + 1);
                            let id = item ? item.value ?? inputForm[idx].pin : inputForm[idx].pin;;
                            setinput(idx,'pin', id)
                        }
                      
                        
                    }

                    setDataDropPin([{value: 0, text: "--- please select ---"}, ...dataPin]);
                }
            }else{

                const responseNews = await getNewsEvent(param);
                const responseTop5News = await pinnedNewsEvent(param);

                
                if ((responseNews.status == 200 || responseNews.data.status == "success")  && responseTop5News.status ==200) {               
                    let dataPin = [];
                    responseNews.data.data.forEach((item) => {
                        dataPin.push({
                            value: item._id,
                            text: item.col1_title_en,
                            rank: item.rank
                        });
                    });

                    responseTop5News.data.data.forEach((item) => {
                        dataPin.push({
                            value: item._id,
                            text: item.title,
                            rank: item.rank
                        });
                    });
                    
                    if (dataPin.length > 0) {
                        for(let idx=0;idx < valuefromparent1.length;idx++){
                            const item = dataPin.find(x => x.rank == idx + 1);
                            let text = item!=null ? item.text ?? valuefromparent1[idx] : valuefromparent1[idx];
                            ChangesetValuefromparent1(idx, text)
                        }
                        for(let idx=0;idx < inputForm.length;idx++){
                            const item = dataPin.find(x => x.rank == idx + 1);
                            let id = item ? item.value ?? inputForm[idx].pin : inputForm[idx].pin;
                            setinput(idx,'pin', id)
                        }
                        
                    }

                    setDataDropPin([{value: 0, text: "--- please select ---"}, ...dataPin]);
                } 
            }
        } catch (error) {
            console.log(error);
        }
    };


    const handleClear = () => {
        setInputForm([
            {pin:0},{pin:0},{pin:0},{pin:0},{pin:0}
        ])
    }

    const handleSaveBtn = async () => {
        try {
            let body = inputForm;
          
            const result = await alertConfirmSave();
                if (result.isConfirmed) {
                    (async () => {
                        await setLoading(true);
                        let response = {status:'fail'}
                        let newBody = {list:[]}
                        body.forEach((item) => {
                            if(item.pin != 0){
                                newBody.list.push(item.pin)
                            }
                        });                             
                        
                        if(type=='promo'||type=='priv')
                        {  
                            response = await createAndUpdatePinned('', {type}, {type:type, ...newBody});
                        }else{
                            response = await createAndUpdatePinnedNews('',{type}, {type:type, ...newBody});  
                        }
                        setLoading(false);
                        if (response.status === "success" || response.status === 200) {
                            const result = await alertSaved();
                                if (result.isConfirmed) {
                                    window.location.reload();
                                }
                        }
                    })();
                }
        } catch (error) {
            console.log('found error ', error);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            await getPinDropDown(type);
        };
        fetchData();
    }, []);
    
    
    return (
        <>
            <style>
                {`
                .select {
                width: 100% !important;
                height: 45px !important;
                border: 1px solid #D1D3D4 !important;
                border-radius: .25rem !important;
                padding: 10px 5px !important;
                }

                .ic-dropdown {
                    width: 23px !important;
                    padding: 5px !important;
                }

                .inp-dropdown {
                    height: auto !important;
                }

                .options-list {
                width: 96% !important;
                border-radius: 6px;
                }

                @media (min-height: 788px) { 
                .pdb-page {
                    padding-bottom: calc(19rem + 1px) !important;
                }
                }
            `}
            </style>
            <Row>
                <Col xs={12}>
                    <font className="font-size07 colorGreen03 fontBold d-flex">
                        <div className='d-flex justify-content-start align-items-start'><img src="assets/icons/ic-promotion.png" className="ic-user01 me-2" alt="" /></div>
                        <div className='d-flex flex-column'>PINNED TOP 5 <br /><span className='colorBlack01'>{type === 'promo' ? 'PROMOTION' : type === 'priv' ? 'PRIVILEGE' : type === 'news' ? 'NEWS' : 'EVENT'}</span></div>
                    </font>
                </Col>
            </Row>
            <Row className='mt-3'>
                <Col xs={1}>
                    <font className="font-size03 colorBlack01 fontBold d-flex align-items-center">
                        No.
                    </font>
                </Col>
                <Col xs={11}>
                    <font className="font-size03 colorBlack01 fontBold d-flex align-items-center">
                        Seq. Management
                    </font>
                </Col>
            </Row>
            {[1, 2, 3, 4, 5].map((num, idx) => (
                <Row className='mt-3' key={num}>
                    <Col xs={1}>
                        <font className="font-size03 colorBlack01 fontBold d-flex align-items-center">
                            {num} 
                        </font>
                    </Col>
                    <Col xs={11}>
                        <Dropdown
                            // options={DataDropPin}
                            options={() => {
                                return getCountExistsSelect() ? filterDropPin : DataDropPin
                            }}
                            setinput={(inputname, value) => {
                                                                setinput(idx, inputname, value)
                                                                filterNotInDropPin(idx)
                                                            }}
                            inputname={"pin"}
                            // ChangesetValuefromparent={(text) => ChangesetValuefromparent1(idx, text)}
                            valuefromparent={DataDropPin.find((item => item.value === inputForm[idx].pin)) ? DataDropPin.find((item => item.value === inputForm[idx].pin)).text : valuefromparent1[idx]}
                            // onChange={(value) => handlePinChange(idx, value)}
                        />
                    </Col>
                </Row>
            ))}
         
            <Row className="mt-4">
                <Col xs={12} className="p-0 d-flex justify-content-center me-4">
                    <button
                        className="btn-cancle01"
                        onClick={() => handleClear()}
                    >
                        CLEAR
                    </button>
                    <button
                        className="btn-save01 ms-3"
                        onClick={(e) => {
                            handleSaveBtn();
                        }}
                    >
                        SAVE
                    </button>
                </Col>
            </Row>
        </>
    )
}

export default Pinned;
